import { petDao } from 'shared/dao/petDao';
import { useQuery } from 'react-query';
import { IPetServiceProps } from 'shared/interfaces/IPets';
import { IPetResponsePayloads } from 'shared/interfaces/IPets';

const { getAnimal: getAnimalDao, getBreed: getBreedDao, getSize: getSizeDao } = petDao();

export const petService = () => {
  const getAnimal = (data?: IPetServiceProps['animalProps']) => {
    return useQuery<IPetResponsePayloads['animalResponsePayload']>(['animal'], () => getAnimalDao(data), {
      enabled: true,
    });
  };

  const getBreed = (data: IPetServiceProps['breedProps']) => {
    return useQuery<IPetResponsePayloads['breedResponsePayload']>(['breed', data?.animal], () => getBreedDao(data), {
      enabled: Boolean(data?.animal),
    });
  };
  const getSize = (data: IPetServiceProps['sizeProps']) => {
    return useQuery<IPetResponsePayloads['sizeResponsePayload']>(
      ['size', data?.animal, data?.breed],
      () => getSizeDao(data),
      {
        enabled: Boolean(data?.animal && data?.breed),
      },
    );
  };

  return {
    getAnimal,
    getBreed,
    getSize,
  };
};
